/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const fr_about_me_description_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avec une solide expérience en développement full-stack, Juslin a dirigé des équipes techniques et lancé plusieurs startups à succès. Il est également un conférencier recherché, partageant ses connaissances lors d'événements technologiques internationaux.`)
};

const en_about_me_description_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With a strong background in full-stack development, Juslin has led technical teams and launched several successful startups. He is also a sought-after speaker, sharing his knowledge at international tech events.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_me_description_2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_me_description_2(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("about_me_description_2", locale)
	if (locale === "fr") return fr_about_me_description_2(inputs)
	return en_about_me_description_2(inputs)
};